
import { mapGetters } from 'vuex'
import Button from '~/components/buttons/Button'
export default {
  components: { Button },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      vxLoyalty: 'loyalty/getProfile',
    }),
  },
}
